import React from 'react';
import PropTypes from 'prop-types';

const HelpIconWithTooltip = ({
  children, position = '', width = '225px', className = '',
}) => (
  <div className={`im-help-icon-with-tooltip ${className}`}>
    <i className="im-help-icon-with-tooltip__icon fa-solid fa-info-circle" />
    <div
      className={`im-help-icon-with-tooltip__content im-help-icon-with-tooltip__content--${position} tooltip`}
      style={{ width }}
    >
      {children}
    </div>
  </div>
);

HelpIconWithTooltip.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  width: PropTypes.string,
  className: PropTypes.string,
};

export default HelpIconWithTooltip;
